import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_standard_avatar = _resolveComponent("standard-avatar");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_btn = _resolveComponent("q-btn");
    return (_openBlock(), _createBlock(_component_q_btn, {
        round: "",
        class: _normalizeClass({
            'q-ma-sm': !_ctx.noPaddings
        }),
        name: "Options",
        size: _ctx.size,
        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click')))
    }, {
        default: _withCtx(() => [
            _createVNode(_component_standard_avatar, {
                size: _ctx.avatarSize,
                pic: _ctx.user ? _ctx.user.profile_img : '',
                "original-size": "profile",
                "pic-class": {
                    'st-wh-53 st-ht-53': true
                },
                "size-type": "profile",
                "component-size": "53px",
                "data-cy": "desktop-user-icon",
                "allow-other-formats": "",
                "show-load": ""
            }, null, 8, ["size", "pic"]),
            _withDirectives(_createVNode(_component_q_badge, {
                color: "red",
                "text-color": "white",
                floating: ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                        name: "priority_high",
                        color: "white",
                        size: "12px"
                    })
                ]),
                _: 1
            }, 512), [
                [_vShow, _ctx.user && !_ctx.user.email_validated]
            ])
        ]),
        _: 1
    }, 8, ["class", "size"]));
}
